/** 엑셀 작은 도우미 — 코어(내보내기 시트 만들기)가 쓰는 부분 (1.2.0: xlsx.ts 는 처음 내보낼 때 import()) */
/** 0 → A, 26 → AA */
export function colName(i) {
    let s = '';
    i++;
    while (i > 0) {
        const m = (i - 1) % 26;
        s = String.fromCharCode(65 + m) + s;
        i = Math.floor((i - 1) / 26);
    }
    return s;
}
/** 엑셀 날짜 일련번호 → YYYY-MM-DD (1900 체계) */
export function excelDate(serial) {
    const ms = Math.round((serial - 25569) * 86400000);
    return new Date(ms).toISOString().slice(0, 10);
}
